module.exports = __webpack_public_path__ + "static/media/app-icon-white.1e8bc490.svg";